<!-- Spinner -->
<div fxLayout="column" fxLayoutAlign="space-around center" style="height:100%">
  <mat-spinner id="loading-spinner"></mat-spinner>
  <!-- Spinner Text -->
  <label id="loading-modal-message-text"> {{ data.modalMessageText }} </label>
</div>
